// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  background-color: #fff;
  /* border-bottom: 1px solid #ccc; */
  position: sticky;
  top: 0;
  z-index: 9;
}

/* Override auto centering and underline */
.-oneX-breadcrumbs {
  border-bottom: none;
  padding: 0;
}

/* Override to keep left margin on mobile */
.-oneX-breadcrumbs div {
  margin-left: 0; /*31px;*/
}

.clickable {
  color: #403C3C;
  font-size: 14px;
}

.subnav {
  align-items: stretch;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 auto;
  padding: 0;
  position: sticky;
  top: 0;
  z-index: 9;
}

.subnav-rightside-menu {
  display: flex;
  flex-direction: row;
}

.subnav-rightside-menu > button {
  font-family: 'MecherleSans', sans-serif;
  font-weight: 600;
}

.subnav-drawer-link {
  padding: 0 12px 0 12px;
}

.subnav-drawer-link-end {
  padding: 0 0 0 12px;
}

.subnav-item {
  display: flex;
  line-height: 56px;
  margin: 0;
}

/* subnav should extend to the maximums of the ODS grid width at each breakpoint */

@media screen and (min-width: 375px) {
  .subnav {
    margin-left: auto;
    margin-right: auto;
    position: relative;
  }
}

@media (min-width: 576px) {
  .subnav {
    margin-left: auto;
    margin-right: auto;
    position: relative;
  }
}

@media (min-width: 768px) {
  .subnav {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .subnav {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .subnav {
    max-width: 1140px;
  }
}

@media screen and (max-width: 767px) {
  .subnav-item:first-child {
    padding-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./projects/lossreporting-app/src/app/header/ui-subnav/ui-subnav.component.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA,0CAA0C;AAC1C;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA,2CAA2C;AAC3C;EACE,cAAc,EAAE,QAAQ;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,UAAU;EAEV,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;AACX;;AAEA,kFAAkF;;AAElF;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".container {\n  background-color: #fff;\n  /* border-bottom: 1px solid #ccc; */\n  position: sticky;\n  top: 0;\n  z-index: 9;\n}\n\n/* Override auto centering and underline */\n.-oneX-breadcrumbs {\n  border-bottom: none;\n  padding: 0;\n}\n\n/* Override to keep left margin on mobile */\n.-oneX-breadcrumbs div {\n  margin-left: 0; /*31px;*/\n}\n\n.clickable {\n  color: #403C3C;\n  font-size: 14px;\n}\n\n.subnav {\n  align-items: stretch;\n  background-color: #fff;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin: 0 auto;\n  padding: 0;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  z-index: 9;\n}\n\n.subnav-rightside-menu {\n  display: flex;\n  flex-direction: row;\n}\n\n.subnav-rightside-menu > button {\n  font-family: 'MecherleSans', sans-serif;\n  font-weight: 600;\n}\n\n.subnav-drawer-link {\n  padding: 0 12px 0 12px;\n}\n\n.subnav-drawer-link-end {\n  padding: 0 0 0 12px;\n}\n\n.subnav-item {\n  display: flex;\n  line-height: 56px;\n  margin: 0;\n}\n\n/* subnav should extend to the maximums of the ODS grid width at each breakpoint */\n\n@media screen and (min-width: 375px) {\n  .subnav {\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n  }\n}\n\n@media (min-width: 576px) {\n  .subnav {\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n  }\n}\n\n@media (min-width: 768px) {\n  .subnav {\n    max-width: 720px;\n  }\n}\n\n@media (min-width: 992px) {\n  .subnav {\n    max-width: 960px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .subnav {\n    max-width: 1140px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .subnav-item:first-child {\n    padding-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
